import LocalizedStrings from 'localized-strings';

import { TeamMemberRole } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    roles: {
      [TeamMemberRole.AccountHolder]: '',
      [TeamMemberRole.Admin]: 'Admin',
      [TeamMemberRole.Accountant]: 'Accountant',
      [TeamMemberRole.Employee]: 'Employee',
      [TeamMemberRole.None]: '',
    },
  },
  fr: {
    roles: {
      [TeamMemberRole.AccountHolder]: '',
      [TeamMemberRole.Admin]: 'Admin',
      [TeamMemberRole.Accountant]: 'Comptable',
      [TeamMemberRole.Employee]: 'Employé·e',
      [TeamMemberRole.None]: '',
    },
  },
} as const);

export default locales;
